import { render, staticRenderFns } from "./BasketScreen.vue?vue&type=template&id=d799401a&"
import script from "./BasketScreen.vue?vue&type=script&lang=js&"
export * from "./BasketScreen.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./BasketScreen.vue?vue&type=style&index=0&id=d799401a&prod&lang=stylus&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports